<template>
    <div class="w-full">
        <hts-form-input
            v-model="markup"
            class="w-full"
            type="number" />
        <div class="bg-white flex content-center justify-end w-8 items-center text-green-600 cursor-pointer">
            <hi-check-icon
                class="icon w-6 h-6"
                @click="handelChangeEditMarkup" />
        </div>
    </div>
</template>

<script lang="ts" setup>
const markupEdit = ref(null)

const showPopupEditMarkup = ref(false)
const openPopupEditMarkup = () => {
  showPopupEditMarkup.value = false
}

const props = defineProps({
  params: {
    type: Object,
    required: true
  }
})

const markup = ref(null)
const { params } = toRefs(props)
const { $formatters } = useNuxtApp()

const data = computed(() => params?.value?.data || null)
const handelChangeEditMarkup = () => {
  if (params.value) {
    params.value.data.pricingEstimate.markup = markup.value || 0
    params && params.value && params.value.handleEditMarkup(params.value)
    params && params.value && params.value.api.redrawRows()
  }
}
onUnmounted(() => {
  params.value.node.dataConfig = {}
})
</script>
